import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ManageNoticeTable from '../organisms/ManageNoticeTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getManageNotices,
  editManageNoticeRead
} from '../../actions/ManageNotices';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      manageNotices: state.manageNotices.manageNotices
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getManageNotices, editManageNoticeRead, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getManageNotices(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    async componentDidMount() {
      isAuthenticated(this.props);
      const accountData = await this.props.actions
        .getAccounts({ cognitoUserId: '' })
        .then(data => this.props.checkSession(data));
      await this.props.actions
        .getManageNotices({
          page: this.props.page,
          limit: this.props.rowsPerPage
        })
        .then(noticeData => this.props.checkSession(noticeData));
      await this.props.actions
        .editManageNoticeRead(accountData.payload.manageAccountId, {
          noticeRead: 1
        })
        .then(noticeReadData => this.props.checkSession(noticeReadData));
      await this.props.actions.getAccounts({ cognitoUserId: '' });
      this.props.updateOpenTable(true);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    handleChangePage,
    openDrawer,
    updateOpenDrawer,
    openTable,
    page
  }) => {
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            お知らせ一覧
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          {openTable && (
            <ManageNoticeTable
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
        </Paper>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
